import { useRef } from "react";
import { Transition } from "react-transition-group";
import { TransitionProps } from "react-transition-group/Transition";
import { publicPath } from "shared/helpers/publicPath";

const SPINNER_STYLE: React.CSSProperties = {
  backgroundImage: `url(${publicPath(
    "krpano/loading/new_loading_spinner.png"
  )})`,
};

/**
 * `$transitionShort` in,
 * `$transitionShort` out
 */
const TIMEOUTS: TransitionProps["timeout"] = {
  enter: 0,
  appear: 300,
  exit: 300,
};

interface SpinnerProps {
  show: boolean;
  underlayClass?: "FaintUnderlay" | "ClearUnderlay" | "NoUnderlay";
  additionalClassNames?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  show,
  underlayClass = "",
  additionalClassNames = "",
}) => {
  const nodeRef = useRef<HTMLDivElement>(null);
  return (
    <Transition
      nodeRef={nodeRef}
      in={show}
      timeout={TIMEOUTS}
      mountOnEnter
      unmountOnExit
    >
      {(transitionState) => (
        <>
          <div
            className={`SharedUnderlay ${underlayClass} ${transitionState}`}
          />
          <div
            ref={nodeRef}
            className={`Spinner ${transitionState} ${additionalClassNames}`}
            style={SPINNER_STYLE}
          />
        </>
      )}
    </Transition>
  );
};
export default Spinner;
